import { sum } from "../utils";
/**
 * Distributes the user defined constant monthly amortization on every loan and reduces the amorization amount to max loan amount if necessary.
 *
 * @param mortgage Array with all loans in mortgage, including loan amount, interest rate and monthly amortization
 * @returns Amortization amounts in array in same order as mortgage param
 *
 */
export function capAmortization(mortgage) {
    return mortgage.map((loan) => Math.min(loan.amount, loan.monthlyAmortization));
}
/**
 * Calculates amortization by user defined constant amortization.
 *
 * @param mortgage Mortgage loans
 * @returns Total monthly amortization and monthly amortization on every loan in same order as mortgage loans in forecast input
 */
export function calculateConstantAmortization(mortgage) {
    const mortgageAmount = sum(mortgage, (loan) => loan.amount);
    const nrOfLoans = mortgage.length;
    let calculatedAmortization = new Array(nrOfLoans).fill(0);
    if (nrOfLoans <= 0 || mortgageAmount <= 0) {
        return {
            monthlyAmortization: calculatedAmortization,
            totalMonthlyAmortization: 0,
        };
    }
    calculatedAmortization = capAmortization(mortgage);
    const totalMonthlyAmortization = calculatedAmortization.reduce((acc, amortization) => acc + amortization, 0);
    return {
        monthlyAmortization: calculatedAmortization,
        totalMonthlyAmortization,
    };
}
